import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Oct 07 2019
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { Inject } from '@logio/typescript-ioc';
import { List } from 'immutable';
import { PromotionConverter } from '@logio/common-be-fe';
import { CRUTransportLayer } from '../CRUTransportLayer';
import { CONSTANTS } from '../../../constants';
import logger from '../../logger';
import api from '../../api';
export var PromotionAreaLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(PromotionAreaLayer, _CRUTransportLayer);

  function PromotionAreaLayer() {
    var _this;

    _classCallCheck(this, PromotionAreaLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionAreaLayer).call(this, CONSTANTS.API.ENDPOINTS.PROMOTIONS));
    /**
     * Find all promotions ids based on area binding records
     * @returns Promise with promotion ids.
     */

    _this.findPromotionIds = function () {
      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_AREAS_BINDING_PROMOTION_IDS).get({
        responseType: 'json'
      }).then(function (response) {
        var result = response.data.result || [];
        return List(result);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };

    return _this;
  }

  _createClass(PromotionAreaLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }]);

  return PromotionAreaLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", PromotionConverter)], PromotionAreaLayer.prototype, "converter", void 0);